import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { detailData } from './config.js';
import downloadSorkorlor from './components/download-sorkorlor.vue';
export default {
  components: {
    downloadSorkorlor: downloadSorkorlor
  },
  data: function data() {
    return {
      params: this.$route.params.state,
      curLang: this.$store.state.settings.curLang.key,
      detailData: detailData,
      tableData: [],
      tableMergeData: [],
      pay_month: '',
      query: {},
      explainVisible: false,
      // 版本说明
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getFullYear() > new Date().getFullYear() - 1;
        }
      },
      loading: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return this.contentViewHeight - 118;
    },
    detail: function detail() {
      return this.detailData[this.params] || {};
    },
    pageTitle: function pageTitle() {
      if (this.params === '5') return this.$t('24916_f7b526d8');
      return this.detail.title;
    }
  }),
  created: function created() {
    this.$route.meta.title = this.pageTitle;
  },
  methods: {
    handlerBack: function handlerBack() {
      // 返回列表页
      this.$router.push({
        path: '/certificate/official'
      });
    },
    // 获取列表
    getSentList: function getSentList() {
      var _this = this;
      this.tableData = [];
      if (!this.pay_month) {
        // this.$message.warning(this.$t('certificate_official_12'))
        return;
      }
      // 由于每个模块的参数不一样，配置中的query是参数的key， this.pay_month为value
      var keys = Object.keys(this.detail.query);
      keys.forEach(function (item) {
        var k = _this.detail.query[item];
        if (item === '1') {
          _this.query[k] = _this.pay_month;
        }
      });
      this.loading = true;
      this.detail.api.apiList(this.query).then(function (res) {
        if (res && res.code === 1) {
          var data = [];
          if (_this.params === '2') {
            res.data.body.forEach(function (item) {
              if (item.income_type.length) {
                item.income_type.forEach(function (type) {
                  data.push(_objectSpread(_objectSpread({}, item), type));
                });
              } else {
                data.push(item);
              }
            });
          } else {
            data = res.data.body;
          }
          _this.tableData = data;
          var header = res.data.header;
          _this.detail.table.forEach(function (item) {
            item.label = header[item.prop];
          });
          _this.generateTableMergeData();
        }
      }).finally(function () {
        _this.loading = false;
      });
    },
    mergeCols: function mergeCols(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      var key = columnIndex + '_' + rowIndex;
      if (this.tableMergeData[key]) {
        return this.tableMergeData[key];
      }
    },
    // 生成合并表格信息
    generateTableMergeData: function generateTableMergeData() {
      // 遍历表格中需要合并的所有单元格
      var header = this.detail.table;
      for (var i = 0; i < this.tableData.length; i++) {
        for (var j = 0; j < header.length; j++) {
          // 初始化行、列坐标信息
          var rowIndex = 1;
          var columnIndex = 1;
          var hear = header[j];
          var item = this.tableData[i];
          var nextItem = this.tableData[i - 1];
          if (i > 0 && item.order_number === nextItem.order_number && hear.row) {
            rowIndex = 0;
          }
          // 比较纵坐标下方元素
          if (rowIndex > 0) {
            rowIndex = this.calculateRowIndex(this.tableData, i, i + 1, 1, hear);
          }
          var key = j + '_' + i;
          this.tableMergeData[key] = [rowIndex, columnIndex];
        }
      }
    },
    calculateRowIndex: function calculateRowIndex(data, index, nextIndex, count, hear) {
      // 比较当前单元格中的数据与同一列之后的单元格是否相同
      var nextItem = data[nextIndex];
      var item = data[index];
      if (nextIndex < data.length && hear.row && item.order_number === nextItem.order_number) {
        this.calculateRowIndex(data, index, ++nextIndex, ++count, hear);
      }
      return count;
    },
    downloadTxt: function downloadTxt() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 下载txt
              _this2.handleDownload('apiTxt', _this2.query);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    downloadPdf: function downloadPdf() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 下载pdf
              _this3.handleDownload('apiPdf', {
                month: _this3.detail.query.pay_month
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    downloadExcel: function downloadExcel() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // 下载excel
              _this4.handleDownload('apiExcel', {
                month: _this4.detail.query.pay_month
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    handleDownload: function handleDownload(type) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var keys, res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (_this5.tableData.length) {
                _context4.next = 3;
                break;
              }
              _this5.$message.warning(_this5.$t('certificate_official_12'));
              return _context4.abrupt("return");
            case 3:
              // 由于每个模块的参数不一样，配置中的query是参数的key， this.pay_month为value
              keys = Object.keys(_this5.detail.query);
              keys.forEach(function (item) {
                var k = _this5.detail.query[item];
                if (item === '1') {
                  _this5.query[k] = _this5.pay_month;
                }
              });
              _context4.next = 7;
              return _this5.detail.api[type](_this5.query);
            case 7:
              res = _context4.sent;
              try {
                _this5.$message.success(res.message);
                if (res.data.object_url) window.location.href = res.data.object_url;
              } catch (_unused) {}
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};